'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(props) {
    return _react2.default.createElement(
        'div',
        { style: { display: 'flex' } },
        _react2.default.createElement(
            'svg',
            {
                height: props.height,
                width: props.width,
                version: '1.1',
                viewBox: '0 0 26 28',
                xmlns: 'http://www.w3.org/2000/svg'
            },
            _react2.default.createElement('path', {
                d: 'M12.659 22.046a9.917 9.917 0 0 1-7.337-3.256l1.285-1.164a8.181 8.181 0 0 0 6.052 2.687c2.298 0 4.504-.98 6.051-2.687l1.286 1.164a9.922 9.922 0 0 1-7.337 3.256M8.349 9.101a1.807 1.807 0 1 1 0 3.613 1.807 1.807 0 0 1 0-3.613m8.388 0a1.807 1.807 0 1 1 0 3.614 1.807 1.807 0 0 1 0-3.614M13 1C5.82 1 0 6.82 0 14s5.82 13 13 13 13-5.82 13-13S20.18 1 13 1',
                fill: props.fill,
                fillRule: 'evenodd',
                stroke: 'none',
                strokeWidth: '1'
            })
        )
    );
};

Icon.propTypes = {
    fill: _propTypes2.default.string,
    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Icon.defaultProps = {
    fill: '#FFF',
    width: '26px',
    height: '28px'
};

Icon.displayName = 'ProductCreditWhite';

exports.default = Icon;